import { render } from "./EditInstagramUser.vue?vue&type=template&id=1fc0e96e&scoped=true"
import script from "./EditInstagramUser.vue?vue&type=script&lang=js"
export * from "./EditInstagramUser.vue?vue&type=script&lang=js"

import "./EditInstagramUser.vue?vue&type=style&index=0&id=1fc0e96e&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fc0e96e"]])

export default __exports__